import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import appConfig from 'app.config'
import { ProductSettingTypes } from 'constants/enums/productTypes'

import tfbank21_logo_symbol_white from 'img/tf-logos/tfbank21-logo-symbol-white.svg'
import './FooterLoggedOut.scss'
import AppContext from 'contexts/AppContext'
import { footerValues } from 'constants/values/footerValues'
import { IFooter } from 'interfaces/i-footer'
import { shouldUseShield } from 'utils/logoHelper'

/**
 * Footer not dependent on type of px application product
 * @returns jsx element Footer for logged out pages
 */
export function FooterLoggedOut() {
	const { market } = useContext(AppContext)
	const { t } = useTranslation()
	const [footerContent, setFooterContent] = useState<IFooter>(footerValues[0])

	const getFooterValues = useCallback(() => {
		console.log(footerValues)
		footerValues.find(
			(val) => val.country === market && setFooterContent(val),
		)
	}, [market])

	useEffect(() => {
		getFooterValues()
	}, [getFooterValues])

	return (
		<div id="footer-logged-out">
			<Row>
				<Col>
					<div id="footer-copyright">
						{shouldUseShield(appConfig?.country?.toLowerCase()) && (
							<img
								src={tfbank21_logo_symbol_white}
								alt="TF Bank"
							/>
						)}
						{`© ${new Date().getFullYear()} ${footerContent?.copyRight}`}
					</div>
					<div id="footer-contact">
						{footerContent?.productSpecific.map((value, key) => {
							if (
								value.productType === ProductSettingTypes.All ||
								(footerContent.country === 'no' &&
									value.productType ===
										ProductSettingTypes.Loan)
							) {
								return (
									<div key={key}>
										<div className="footer-contact-phone-number">
											<a
												href={`tel:${value.contactInformation.phoneNumber}}`}>
												{value.contactInformation
													.phoneNumber +
													(footerContent.country ===
													'no'
														? ` (${t('Loan')})`
														: '')}
											</a>
											{','}
										</div>
									</div>
								)
							} else return null
						})}
						{footerContent !== undefined &&
							Object.entries(footerContent?.address).map(
								([key, value]) => {
									return (
										value +
										(key === 'zipCodeAndCity' ? '' : ', ')
									)
								},
							)}
					</div>
				</Col>
			</Row>
			{footerContent.country === 'no' && ( // extra company info for card applications
				<Row>
					<Col>
						<div id="footer-copyright">
							{`© ${new Date().getFullYear()} ${footerContent?.copyRight2}`}
						</div>
						<div id="footer-contact">
							{footerContent?.productSpecific.map(
								(value, key) => {
									if (
										value.productType ===
										ProductSettingTypes.Card
									) {
										return (
											<div key={key}>
												<div className="footer-contact-phone-number">
													<a
														href={`tel:${value.contactInformation.phoneNumber}}`}>
														{value
															.contactInformation
															.phoneNumber +
															` (${t(
																'CreditCard',
															)})`}
													</a>
													{','}
												</div>
											</div>
										)
									} else return null
								},
							)}
							{footerContent?.address2 &&
								Object.entries(footerContent.address2).map(
									([key, value]) => {
										return (
											value +
											(key === 'zipCodeAndCity'
												? ''
												: ', ')
										)
									},
								)}
						</div>
					</Col>
				</Row>
			)}
		</div>
	)
}
